/**
 * Author: Ayesha Shaikh
 * Date: 04-06-2025

 */
import { Collapse, Grid, MenuItem, Select, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import CustomNoRowsOverlay from "../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import MainCard from "../../../components/Maincard";
import CustomAutocompleteComp from "../../newComponent/AutocompleteComp";
import CustomTextFieldComp from "../../newComponent/customTextFieldComp";
import SearchButton from "../../newComponent/NewButtonComp/SearchButton";
import ClearButtonComp from "../../newComponent/NewButtonComp/ResetButtonComp";
import SearchTextFieldComp from "../../newComponent/newtextfieldComp/SearchTextFieldComp";
import { useGetTokenOrLogout } from "../../../utils/token";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import LoaderComp from "../../newComponent/LoaderComp/Loader";
import CustomPopup from "../../../components/CustomPopup";
import WalkinDetailsPopup from "./WalkinDetailsPopup";
import { useDateUtils } from "../../../utils/formatTime";
import { CSVExport } from "../../components/ui-component/table/CSVExport";
import NewEnquiryComp from "../../../pages/AllUserDashboards/popupComponent/NewEnquiryComp";
import DemoDetails from "../AdvisorTaskWiseReport/DemoDetails";
import EnrollDetails from "../../../pages/AllUserDashboards/popupComponent/EnrollDetails";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function AdvisorWiseWalkinReport({ open }) {
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");
  const getTokenOrLogout = useGetTokenOrLogout();
  const { todaysDate, oneMonthAgoDate } = useDateUtils();
  const [loading, setloading] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [searchData, setSearchData] = useState([]);

  const [fromDate, setFromDate] = useState();
  const [toDate, setTodate] = useState();
  const [filterType, setFilterType] = useState("today");

  const [assignToList, setAssignToList] = useState([]);
  const [assignTo, setAssignTo] = useState([]);
  const [selectedData, setSelectedData] = useState({});

  const [detailsData, setDetailsData] = useState([]);
  const [openpopup, setOpenPopup] = useState(false);
const [statusName, setStatusName] =useState(null)
  const [headerName, setHeaderName] = useState({});
  const [isDownloadAccess, setIsDownloadAccess] = useState(false);
  const [exportData, setExportData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/getadvisors/${userId}`
        );
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setAssignToList(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const allAssignToList = [{ first_name: "Select All" }, ...assignToList];
  const handleAssignToChange = (event, value) => {
    if (value.some((option) => option.first_name === "Select All")) {
      setAssignTo(assignToList);
    } else {
      setAssignTo(value);
    }
  };

  const handleFilterChange = (event) => {
    setFromDate(null);
    setTodate(null);
    setFilterType(event.target.value);
  };

  // Fetch Data

  const handleApplyFilter = async (event) => {
    if (filterType === "custom" && (!fromDate || !toDate)) {
      showSnackbar("Please select date", "error");
      return;
    }

    setloading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      walkin_from_date: fromDate || null,
      walkin_to_date: toDate || null,
      user_id: parseInt(userId),
      filter: filterType,

      assign_to: assignTo.map((i) => i.user_id),
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}reports/getAdvisorwalkinreport`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );
      const result = await response.json();
      if (response.ok) {
        const sortedData = result.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setOriginalData(sortedData);
        setRowData(sortedData);
        setSearchData(sortedData);
        setloading(false);
      } else if (response.status === 401) {
        showSnackbar(result.message, "error");
        setloading(false);
        setRowData([]);
        setSearchData([]);
      } else if (response.status === 403) {
        showSnackbar(result.message, "error");
        setloading(false);
        setRowData([]);
        setSearchData([]);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
        setloading(false);
        setRowData([]);
        setSearchData([]);
      } else {
       showSnackbar("Error", `Server Error: ${result.message}`, "error");


        setloading(false);
        setRowData([]);
        setSearchData([]);
      }
    } catch (error) {
      showSnackbar("Server Error", "error");
      setloading(false);
      setRowData([]);
      setSearchData([]);
    }
  };

  // First Render
  useEffect(() => {
    handleApplyFilter();
  }, []);

  const columns = [
    {
      field: "name",
      headerName: "Appointment For",
      flex: 1.5,
      minWidth: 250,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
  valueGetter: (params) =>
        `${params.row?.first_name || ""}{" "}
          ${params.row?.last_name || ""}`,
      renderCell: (params) => {
        const isLastRow = params?.row.first_name === "Total";
        return (
          <div
            style={{
              color: isLastRow ? "black" : "",

              fontWeight: isLastRow ? 700 : 500,
            }}
          >
            {params?.row?.first_name} {params?.row?.last_name}
          </div>
        );
      },
    },

    {
      field: "newEnquiry",
      headerName: "Total Enquiry",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const isLastRow = params?.row.first_name === "Total";
        return (
          <Typography
            variant="h5"
            style={{
              color: isLastRow ? "black" : "blue",
              cursor: "pointer",
              fontWeight: isLastRow ? 700 : 500,
            }}
            onClick={() =>
              isLastRow
                ? undefined
                : getDetailsData(
                    params?.row,
                    "newEnquiry",
                    "Total Enquiry Walkin"
                  )
            }
          >
            {params.row?.newEnquiry}
          </Typography>
        );
      },
    },

    {
      field: "direct",
      headerName: "Direct",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const isLastRow = params?.row.first_name === "Total";
        return (
          <Typography
            variant="h5"
            style={{
              color: isLastRow ? "black" : "blue",
              cursor: "pointer",
              fontWeight: isLastRow ? 700 : 500,
            }}
            onClick={() =>
              isLastRow
                ? undefined
                : getDetailsData(params?.row, "direct", "Direct Walkin")
            }
          >
            {params.row?.direct}
          </Typography>
        );
      },
    },
    {
      field: "indirect",
      headerName: "InDirect",
      flex: 1,
      minWidth: 200,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const isLastRow = params?.row.first_name === "Total";
        return (
          <Typography
            variant="h5"
            style={{
              color: isLastRow ? "black" : "blue",
              cursor: "pointer",
              fontWeight: isLastRow ? 700 : 500,
            }}
            onClick={() =>
              isLastRow
                ? undefined
                : getDetailsData(params?.row, "indirect", "Indirect Walkin")
            }
          >
            {params.row?.indirect}
          </Typography>
        );
      },
    },
    {
      field: "existing",
      headerName: "Existing",
      flex: 1,
      minWidth: 200,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const isLastRow = params?.row.first_name === "Total";
        return (
          <Typography
            variant="h5"
            style={{
              color: isLastRow ? "black" : "blue",
              cursor: "pointer",
              fontWeight: isLastRow ? 700 : 500,
            }}
            onClick={() =>
              isLastRow
                ? undefined
                : getDetailsData(params?.row, "existing", "Existing Walkin")
            }
          >
            {params.row?.existing}
          </Typography>
        );
      },
    },

    {
      field: "demoScheduled",
      headerName: "Demo Scheduled",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const isLastRow = params?.row.first_name === "Total";
        return (
          <Typography
            variant="h5"
            style={{
              color: isLastRow ? "black" : "blue",
              cursor: "pointer",
              fontWeight: isLastRow ? 700 : 500,
            }}
            onClick={() =>
              isLastRow
                ? undefined
                : getDetailsData(params?.row, "demoScheduled", "Demo Scheduled")
            }
          >
            {params.row?.demoScheduled}
          </Typography>
        );
      },
    },

    {
      field: "enrolled",
      headerName: "Enrolled",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const isLastRow = params?.row.first_name === "Total";
        return (
          <Typography
            variant="h5"
            style={{
              color: isLastRow ? "black" : "blue",
              cursor: "pointer",
              fontWeight: isLastRow ? 700 : 500,
            }}
            onClick={() =>
              isLastRow
                ? undefined
                : getDetailsData(params?.row, "enrolled", "Enrolled")
            }
          >
            {params.row?.enrolled}
          </Typography>
        );
      },
    },

    {
      field: "superProspective",
      headerName: "Super Prospective",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const isLastRow = params?.row.first_name === "Total";
        return (
          <Typography
            variant="h5"
            style={{
              color: isLastRow ? "black" : "blue",
              cursor: "pointer",
              fontWeight: isLastRow ? 700 : 500,
            }}
            onClick={() =>
              isLastRow
                ? undefined
                : getDetailsData(
                    params?.row,
                    "superProspective",
                    "Super Prospective"
                  )
            }
          >
            {params.row?.superProspective}
          </Typography>
        );
      },
    },

    {
      field: "recycled",
      headerName: "Recycled",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const isLastRow = params?.row.first_name === "Total";
        return (
          <Typography
            variant="h5"
            style={{
              color: isLastRow ? "black" : "blue",
              cursor: "pointer",
              fontWeight: isLastRow ? 700 : 500,
            }}
            onClick={() =>
              isLastRow
                ? undefined
                : getDetailsData(params?.row, "recycled", "Recycled")
            }
          >
            {params.row?.recycled}
          </Typography>
        );
      },
    },
  ];

// export

  useEffect(() => {
    fetch(`${API_ENDPOINT}route/downloadaccess/${userId}`)
      .then((response) => {
        if (response.ok) {
          setIsDownloadAccess(true);
        } else {
          setIsDownloadAccess(false);
        }
      })
      .catch((err) => {
        setIsDownloadAccess(false);
      });
  }, [userId]);

    useEffect(() => {
      const exportData = rowData.map((row) => ({
        name: `${row?.first_name} ${row?.last_name? row?.last_name :""}`,
        new_enquiry : row?.newEnquiry,
        direct_walkin: row?.direct,
        indirect_walkin: row?.indirect,
        existing_walkin: row?.existing,
        demo_scheduled:row?.demoScheduled,
        enrolled:row?.enrolled,
        super_prospective : row?.superProspective,
  
  recycled: row?.recycled
  
      }));
      setExportData(exportData);
    }, [rowData]);


  const handleOpenPopup = (rowData, status, headerName) => {
    setOpenPopup(true);
    setSelectedData(rowData);
setStatusName(status)
    setHeaderName(headerName);
  };

  const handleClosePopup = () => setOpenPopup(false);

  const getDetailsData = async (rowData, status, headerName) => {
    setloading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      user_id :userId,
      walkin_from_date: fromDate || null,
      walkin_to_date: toDate || null,
     filter:filterType ,
      assign_to: rowData?.user_id,
     
      filter_type: status,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}reports/getAdvisorwalkinreport-with-details`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );
      const result = await response.json();
      if (response.ok) {
        const sortedData = result.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setDetailsData(sortedData);

        setloading(false);
        handleOpenPopup(rowData, status, headerName);
      } else if (response.status === 401) {
        showSnackbar(result.message, "error");
        setloading(false);
      } else if (response.status === 403) {
        showSnackbar(result.message, "error");
        setloading(false);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
        setloading(false);
      } else {
showSnackbar("Error", `Server Error: ${result.message}`, "error");
        setloading(false);
      }
    } catch (error) {
      showSnackbar("Server Error", "error");
      setloading(false);
    }
  };


  const handleSearchByName = (e) => {
    const value = e.target.value.toLowerCase().replace(/\s+/g, ""); // Normalize search value (lowercase and remove spaces)

    let filteredData1 = searchData.filter((data) => {
      // Check each field for a match with the search value
      const fieldsToSearch = [
        `${data?.first_name || ""} ${data?.last_name || ""}`,
        `${data?.direct || ""}`,
        `${data?.indirect || ""}`,
        `${data?.existing || ""}`,
        `${data?.newEnquiry || ""}`,
        `${data?.superProspective || ""}`,
        `${data?.enrolled || ""}`,
        `${data?.demoScheduled || ""}`,
        `${data?.recycled || ""}`,
      ];

      // Check if any of the fields contain the search value
      return fieldsToSearch.some((field) =>
        field.toLowerCase().replace(/\s+/g, "").includes(value)
      );
    });
    setRowData(filteredData1); // Update the filtered data
  };

  return (
    <>
      <LoaderComp isLoading={loading} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Collapse in={open} fullWidth>
            <MainCard>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={3} md={4} sm={6}>
                  <Typography variant="h6">Appointment For</Typography>

                  <CustomAutocompleteComp
                    multiple
                    limitTags={1}
                    value={assignTo}
                    options={allAssignToList}
                    onChange={handleAssignToChange}
                    getOptionLabel={(option) =>
                      `${option.first_name ? option.first_name : ""} ${
                        option.last_name ? option.last_name : ""
                      }`
                    }
                    tooltipContent={(option) =>
                      `${option.first_name ? option.first_name : ""} ${
                        option.last_name ? option.last_name : ""
                      }`
                    }
                  />
                </Grid>

                <Grid item xs={12} lg={2} md={4} sm={6}>
                  <Typography variant="h6">Walkin Date Filter</Typography>
                  <Select
                    value={filterType}
                    onChange={handleFilterChange}
                    fullWidth
                    style={{ borderRadius: "10px" }}
                    size="medium"
                  >
                    <MenuItem value="today">Today</MenuItem>
                    <MenuItem value="currentweek">This Week</MenuItem>
                    <MenuItem value="currentmonth">This Month</MenuItem>
                    <MenuItem value="custom">Custom</MenuItem>
                  </Select>
                </Grid>

                {filterType === "custom" && (
                  <>
                    <Grid item xs={12} lg={2} md={4} sm={6}>
                      <Typography variant="h6"> Appointment Date From</Typography>
                      <CustomTextFieldComp
                        size="normal"
                        fullWidth
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        InputProps={{
                          style: { borderRadius: "10px" },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} lg={2} md={4} sm={6}>
                      <Typography variant="h6"> Appointment Date To</Typography>
                      <CustomTextFieldComp
                        size="normal"
                        fullWidth
                        type="date"
                        value={toDate}
                        onChange={(e) => setTodate(e.target.value)}
                        InputProps={{
                          style: { borderRadius: "10px" },
                        }}
                      />
                    </Grid>
                  </>
                )}

                <Grid item xs={12} lg={2}>
                  <Typography sx={{ visibility: "hidden" }}>Hidden </Typography>
                  <SearchButton showIcon={true} onClick={handleApplyFilter} />
                </Grid>
              </Grid>
            </MainCard>
          </Collapse>
        </Grid>

        <Grid item xs={12}>
          <MainCard>
            <Grid container>
              <Grid
                item
                xs={12}
                textAlign="end"
                container
                justifyContent="end"
                gap={1}
              >
                <SearchTextFieldComp onChange={handleSearchByName} />
                {isDownloadAccess && (
                  <CSVExport
                    data={exportData}
                    filename="advisor-walkin-report.csv"
                  />
                )}
              </Grid>
              <Grid item xs={12}>
                <DataGrid
                  rows={rowData}
                  columns={columns}
                  autoHeight
                  slots={{
                    noRowsOverlay: CustomNoRowsOverlay,
                  }}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 25,
                      },
                    },
                  }}
                  sx={{ marginTop: "20px" }}
                  pageSizeOptions={[25, 50, 100]}
                />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

        <CustomPopup
              open={openpopup}
              onClose={handleClosePopup}
              title={`${headerName}  Details`}
              maxWidth="lg"
              showDivider={true}
              component={
                statusName === "direct" ||
                statusName === "indirect" ||
                statusName === "existing" ||
                statusName === "newEnquiry" ? (
                  <WalkinDetailsPopup
                    detailsData={detailsData}
                    isDownloadAccess={isDownloadAccess}
                    selectedData={selectedData}
                    fromDate={fromDate}
                    toDate={toDate}
                     selectedFilter={filterType}
                     userpopup={true}

                  />
                ) : statusName === "superProspective" || statusName === "recycled" ? (
                  <NewEnquiryComp
                    selectedFilter={filterType}
                    SelectedData={detailsData}
                    fromDate={fromDate}
                    toDate={toDate}
                  />
                ) : statusName === "demoScheduled" ? (
                  <DemoDetails
                    SelectedData={detailsData}
                    selectedFilter={filterType}
                    fromDate={fromDate}
                    toDate={toDate}
                  />
                ) : (
                  <EnrollDetails
                    SelectedCardData={detailsData}
                    selectedFilter={filterType}
                    fromDate={fromDate}
                    toDate={toDate}
                  />
                )
              }
              />
    </>
  );
}
